import React, { useState, useContext } from 'react';
import { Button, DialogActions, Grid, TextField, CircularProgress, IconButton } from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { AlertMessagesContext } from 'react-alert-messages';
import ExpenseTypeService from 'services/ExpenseTypeService';
import { useTranslation } from 'react-i18next';

export default function ExpenseTypeFormDialog({ handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(false);

  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleCreateExpenseType = async () => {
    setLoading(true);
    try {
      const newExpenseType = await ExpenseTypeService.createExpenseType(data);
      postAlertMessage({ text: tPopup('Expense type created successfully'), type: 'success' });
      handleSuccess(newExpenseType);
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Add Expense Type')}</h2>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="text"
                  value={data.name || ''}
                  onChange={(e) => {
                    setData({ ...data, name: e.target.value.toUpperCase() });
                  }}
                />
              </Grid>
            </Grid>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!data.name || data.name === '' || isLoading}
                onClick={handleCreateExpenseType}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Creating...')}
                  </>
                ) : (
                  tCommon('Create')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
